import * as React from 'react';
import './_CardPriority.scss';
import { Button, ButtonDropdown, Icon, SelectList, SelectListItem } from 'kui';
import { NO_PRIORITY, PRIORITY_ICONS, SET_PRIORITY } from '../../../../../helpers/constants';
import { ECardPriorityVariant, ICardPriorityProps } from './types';
import { CARD_SELECT_PRIORITY, CLASS_CARD_PRIORITY } from './constants';
import {
    CARD_ACTIONS_PORTAL,
    CARD_CONTROL_CLASS,
    CARD_TEMPLATES_PORTAL,
    DEFAULT_PORTAL, LIST_CONTROL_CLASS
} from '../../../../../main/kanbanView';
import { v4 as uuidv4 } from 'uuid';
import { CLASS_ABSTRACT_DASHBOARD_SCROLL_PREVENT } from '../../../../../../abstracts/constants';
import { TOP_BAR_CLASS } from '../../../../../main/topBar/constants';
import { CLASS_ASIDE_PANEL_ACTIONS_BUTTON_CONTAINER } from '../../../../../aside_panel/asidePanel/components/AsidePanelActionsButton/constants';

export function CardPriority({
    priority,
    isReadonly,
    isTemplates,
    listId,
    portal,
    variant = ECardPriorityVariant.BASE,
    onChange,
    onDropDownOpen,
    onShowBoardLimitSnackbarIfNeeded,
}: ICardPriorityProps) {
    const priorityObj = PRIORITY_ICONS.find(item => item.priority === String(priority) || !priority && !Number(item.priority));

    const className = CLASS_CARD_PRIORITY;
    const classButton = className + '__button';
    const classIcon = className + '__icon';

    const [isOpened, setOpened] = React.useState(false);
    const [classUnique] = React.useState(classButton + uuidv4());

    const onOpen = () => {
        const topBar = document.querySelector(`.${TOP_BAR_CLASS}`) as HTMLElement;
        if (topBar) {
            topBar.style.zIndex = 'unset';
        }
        onDropDownOpen();
        setOpened(true);
        setTimeout(()=>{
            const button = document.querySelector('.' + classUnique) as HTMLElement;
            if (button) button.focus();
        }, 100);
    }

    const onClose = () => {
        setOpened(false);
        const topBar = document.querySelector(`.${TOP_BAR_CLASS}`) as HTMLElement;
        if (topBar) {
            topBar.style.zIndex = '120'; // $z-fold * 1.2
        }
    }

    const portalAttributes = portal ? {
        portal: true,
        portalId: isTemplates ? CARD_TEMPLATES_PORTAL : DEFAULT_PORTAL,
    } : {};

    React.useEffect(() => {
        function onScroll() {
            onClose();
        }
        if (isOpened && !isTemplates && variant === ECardPriorityVariant.SMALL) {
            window.addEventListener('scroll', onScroll);
        }

        return () => window.removeEventListener('scroll', onScroll);
    }, [isOpened]);

    const PriorityNoIcon = require(`!!@svgr/webpack!./no-priority_24.svg`).default;
    const PriorityNoIconSmall = require(`!!@svgr/webpack!./no-priority_16.svg`).default;

    return (
        <div className={className + '__wrapper'} onClick={onShowBoardLimitSnackbarIfNeeded}>
            <ButtonDropdown
                className={`
                    ${className}
                    ${className + '--' + variant}
                    ${!priority ? className + '--no' : ''}
                    ${CARD_CONTROL_CLASS}
                `}
                dropdownClassName={`
                    ${className + '__dropdown'}
                    ${className + '__dropdown--' + variant}
                    ${CARD_CONTROL_CLASS}
                    ${CLASS_ABSTRACT_DASHBOARD_SCROLL_PREVENT}
                    ${LIST_CONTROL_CLASS}
                `}
                directionVertical={variant === ECardPriorityVariant.SMALL ? 'auto' : 'down'}
                disabled={isReadonly}
                { ...portalAttributes }
                onOpen={onOpen}
                onClose={onClose}
                opened={isOpened}
                notBlurClasses={[CLASS_ASIDE_PANEL_ACTIONS_BUTTON_CONTAINER + '--priority']}
            >
                <Button
                    className={`${classButton} ${classUnique}`}
                    variant={variant === ECardPriorityVariant.SMALL ? 'icon' : 'icon-text'}
                    tooltip={variant === ECardPriorityVariant.SMALL && !isOpened ? priorityObj.text : null} // нет тултипа когда открыто, иначе на карте не закрывалось
                >
                    {
                        priorityObj.priority === NO_PRIORITY ?
                            variant === ECardPriorityVariant.SMALL ? <PriorityNoIconSmall className={classIcon} /> : <PriorityNoIcon className={classIcon} />
                            : <Icon
                                className={classIcon}
                                size={24}
                                xlink={priorityObj.icon}
                            />
                    }
                    {variant === ECardPriorityVariant.BASE &&
                        <>
                            <div className={className + '__label'}>
                                {priorityObj.priority === NO_PRIORITY ? SET_PRIORITY : priorityObj.text}
                            </div>
                            <Icon
                                className={className + '__arrow'}
                                size={24}
                                xlink={'arrow-down'}
                            />
                        </>
                    }
                </Button>
                <SelectList
                    active={PRIORITY_ICONS.findIndex(item => item.priority === String(priority) || !priority && !Number(item.priority))}
                >
                    {PRIORITY_ICONS.map((item) => (
                        <SelectListItem
                            className={!Number(item.priority) ? 'no-priority' : ''}
                            icon={!Number(item.priority) ? null : item.icon}
                            iconSize={24}
                            key={item.priority}
                            value={item.priority}
                            onClick={() => onChange(item.priority)}
                            tabIndex={0}
                        >
                            <>
                                {!Number(item.priority) && <PriorityNoIcon />}
                                {item.text}
                            </>
                        </SelectListItem>
                    ))}
                </SelectList>
            </ButtonDropdown>
        </div>
    );
};
